import { createContext } from "react";

export const todoContext = createContext();